module.exports = __webpack_public_path__ + "static/media/usuarios.43ae6a09.svg";